import { createSelector } from 'reselect';
import { RootState } from 'store/types';
import { oc } from 'ts-optchain';
import { SearchCriteria } from './types';

export const pharmaciesSelector = (state: RootState) => state.amwell.activeConsumer.pharmacies;

export const pharmaciesListDataSelector = createSelector(pharmaciesSelector, p => p.list.data);

export const pharmaciesListLoadingSelector = createSelector(
  pharmaciesSelector,
  p => p.list.loading
);

export const pharmaciesListErrorSelector = createSelector(pharmaciesSelector, p => p.list.error);

export const lastSearchCriteriaSelector = createSelector(pharmaciesSelector, p => {
  const searchCriteria = oc(p.list).lastSearchCriteria(null);
  const state = oc(searchCriteria).state(null);
  const city = oc(searchCriteria).city('');
  const zipCode = oc(searchCriteria).zipCode('');
  const pharmacyType = oc(searchCriteria).pharmacyType('');

  return { state, city, zipCode, pharmacyType } as SearchCriteria;
});

export const preferredPharmacyDataSelector = createSelector(
  pharmaciesSelector,
  p => p.preferred.data
);

export const preferredPharmacyLoadingSelector = createSelector(
  pharmaciesSelector,
  p => p.preferred.loading
);

export const preferredPharmacyWasUpdatedSelector = createSelector(
  pharmaciesSelector,
  p => p.preferred.preferredPharmacyWasUpdated
);

export const preferredPharmacyErrorSelector = createSelector(
  pharmaciesSelector,
  p => p.preferred.error
);

// old and mobile
// const loadingSelector = state => state.fetchingByAction['AMWELL.GET_PHARMACY'];
// const pharmacySelector = state => state.pharmacy;
// const pharmaciesSelector = state => state.pharmacies;
// const pharmaciesInputSelector = state => state.pharmaciesInput;

// export const amWellSelector = state => state.amWellExperience;

// export const pharmacyLoadingSelector = createSelector(amWellSelector, loadingSelector);

// export const pharmacyDataSelector = createSelector(amWellSelector, pharmacySelector);

// export const pharmaciesDataSelector = createSelector(amWellSelector, pharmaciesSelector);

// export const pharmaciesInputDataSelector = createSelector(amWellSelector, pharmaciesInputSelector);
